import Units from "utils/units" // eslint-disable-line import/no-named-as-default
import { BElement } from "utils/base-component"

export class MobileUnitSwitcher {
  private cssClass: string
  private lengthMetricRadio: BElement
  private lengthImperialRadio: BElement
  private speedMetricRadio: BElement
  private speedImperialRadio: BElement
  private tempMetricRadio: BElement
  private tempImperialRadio: BElement

  constructor(cssClass: string) {
    this.cssClass = cssClass
    MobileUnitSwitcher.loadInitialUnits()
    this.initializeElements()
    this.setInitialStates()
    this.addEventListeners()
  }

  private static loadInitialUnits() {
    // Load initial units from body class
    const isImperial = document.body.classList.contains("js-units-i")
    const initialUnits = isImperial ? "Imperial" : "Metric"

    // Set the Units instance to the correct initial state
    Units.current = {
      temperature: initialUnits,
      length: initialUnits,
      speed: initialUnits,
    }
  }

  private static saveUnitsChoice(
    unitType: "length" | "speed" | "temperature",
    value: "Metric" | "Imperial",
  ) {
    // Save to cookie using the same method
    const cookieDomain = document.body.dataset.cDomain || window.location.hostname
    const cookieValue = value === "Imperial" ? "i" : "m"
    MobileUnitSwitcher.setPermanentCookie("u", cookieValue, cookieDomain)
  }

  private static setPermanentCookie(name: string, value: string, domain: string) {
    // Replicate the setPermanentCookie function from all_pages.coffee
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 20)
    const cookieString = `${name}=${value}; path=/; domain=${domain}; expires=${expirationDate.toUTCString()}`
    document.cookie = cookieString
  }

  private initializeElements() {
    const lengthMetricRadio = document.querySelector(".menu-nav__settings-input--length-met")
    this.lengthMetricRadio = new BElement(lengthMetricRadio, this.cssClass)

    const lengthImperialRadio = document.querySelector(".menu-nav__settings-input--length-imp")
    this.lengthImperialRadio = new BElement(lengthImperialRadio, this.cssClass)

    const speedMetricRadio = document.querySelector(".menu-nav__settings-input--speed-met")
    this.speedMetricRadio = new BElement(speedMetricRadio, this.cssClass)

    const speedImperialRadio = document.querySelector(".menu-nav__settings-input--speed-imp")
    this.speedImperialRadio = new BElement(speedImperialRadio, this.cssClass)

    const tempMetricRadio = document.querySelector(".menu-nav__settings-input--temp-met")
    this.tempMetricRadio = new BElement(tempMetricRadio, this.cssClass)

    const tempImperialRadio = document.querySelector(".menu-nav__settings-input--temp-imp")
    this.tempImperialRadio = new BElement(tempImperialRadio, this.cssClass)
  }

  private setInitialStates() {
    ;(this.lengthMetricRadio.element as HTMLInputElement).checked =
      Units.current.length === "Metric"
    ;(this.lengthImperialRadio.element as HTMLInputElement).checked =
      Units.current.length === "Imperial"
    ;(this.speedMetricRadio.element as HTMLInputElement).checked = Units.current.speed === "Metric"
    ;(this.speedImperialRadio.element as HTMLInputElement).checked =
      Units.current.speed === "Imperial"
    ;(this.tempMetricRadio.element as HTMLInputElement).checked =
      Units.current.temperature === "Metric"
    ;(this.tempImperialRadio.element as HTMLInputElement).checked =
      Units.current.temperature === "Imperial"
  }

  private addEventListeners() {
    this.lengthMetricRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ length: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("length", "Metric")
      }
    })

    this.lengthImperialRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ length: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("length", "Imperial")
      }
    })

    this.speedMetricRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ speed: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("speed", "Metric")
      }
    })

    this.speedImperialRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ speed: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("speed", "Imperial")
      }
    })

    this.tempMetricRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ temperature: "Metric" })
        MobileUnitSwitcher.saveUnitsChoice("temperature", "Metric")
      }
    })

    this.tempImperialRadio.element.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      if (target.checked) {
        Units.change({ temperature: "Imperial" })
        MobileUnitSwitcher.saveUnitsChoice("temperature", "Imperial")
      }
    })
  }
}
